import { gql } from '@apollo/client'

export const AUDIT_FRAGMENT = gql`
  fragment Audit on Audit {
    id
    employee {
      firstName
      lastName
      email
    }
    dateCompleted
    status
    notes
    store {
      id
      name
      category
      address {
        address1
      }
    }
  }
`
